import React from 'react'
import Select from 'react-dropdown-select'
import './styles.scss'

const FilterSelect = ({ filters, activeFilter, onChange }) => {
  let options = filters.map(f => { return { value: f } })
  options.unshift({ value: 'All' })
  return (
    <Select
      values={[activeFilter]}
      options={options}
      labelField="value"
      searchable={false}
      onChange={(values) => onChange(values[0])}
    />
  )
}

export default FilterSelect